import { React, useContext, useEffect, useState } from "react";
import ProjectContext from "../../context/ProjectContext";
import AuthContext from "../../context/userAuth.context";
import PreviewLottieTransition from "../previewpop/PreviewLottieSlideTransition";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import Swal from "sweetalert2";

const SlideTransitions = ({
  ShowTransitionPanel,
  setShowTransitionPanel,
  LayersData,
}) => {
  const [SelectedType, setSelectedType] = useState("");
  const [SelectedName, setSelectedName] = useState("");
  const [IconSource1, setIconSource1] = useState("");
  const [IconSource2, setIconSource2] = useState("");
  const [IconSource3, setIconSource3] = useState("");
  const [IconSource4, setIconSource4] = useState("");
  const [IconSource5, setIconSource5] = useState("");
  const [IconSource6, setIconSource6] = useState("");
  const [IconSource7, setIconSource7] = useState("");
  const [IconSource8, setIconSource8] = useState("");
  const [IconSource9, setIconSource9] = useState("");
  const [IconSource10, setIconSource10] = useState("");
  // const [IconSource11, setIconSource11] = useState("");
  const [IconSource12, setIconSource12] = useState("");
  const [IconSource13, setIconSource13] = useState("");
  const [IconSource14, setIconSource14] = useState("");
  const [IconSource16, setIconSource16] = useState("");
  const [IconSource17, setIconSource17] = useState("");
  const [IconSource15, setIconSource15] = useState("");
  const [IconSource18, setIconSource18] = useState("");

  useEffect(() => {
    //alert("Loading Icons");
    setIconSource1(apiBaseurl + "/Assets/SlideTransitions/Icons/ArrowMove.svg");
    setIconSource2(
      apiBaseurl + "/Assets/SlideTransitions/Icons/CircleTunnel.svg"
    );
    setIconSource3(
      apiBaseurl + "/Assets/SlideTransitions/Icons/SquarePegs.svg"
    );
    setIconSource4(apiBaseurl + "/Assets/SlideTransitions/Icons/3Panes.svg");
    setIconSource5(
      apiBaseurl + "/Assets/SlideTransitions/Icons/FadingShapes.svg"
    );
    setIconSource6(
      apiBaseurl + "/Assets/SlideTransitions/Icons/ArrowShift.svg"
    );
    setIconSource7(apiBaseurl + "/Assets/SlideTransitions/Icons/LineSwipe.svg");
    setIconSource8(
      apiBaseurl + "/Assets/SlideTransitions/Icons/SquareSlice.svg"
    );
    setIconSource9(apiBaseurl + "/Assets/SlideTransitions/Icons/LeftSwipe.svg");
    setIconSource10(apiBaseurl + "/Assets/SlideTransitions/Icons/Spirals.svg");
    // setIconSource11(apiBaseurl + "/Assets/SlideTransitions/Icons/Tricut.svg");
    setIconSource12(apiBaseurl + "/Assets/SlideTransitions/Icons/HorDrop.svg");
    setIconSource16(apiBaseurl + "/Assets/SlideTransitions/Icons/Bars.svg");
    setIconSource17(apiBaseurl + "/Assets/SlideTransitions/Icons/WipeTop.svg");
    setIconSource13(apiBaseurl + "/Assets/SlideTransitions/Icons/SideWave.svg");
    setIconSource14(
      apiBaseurl + "/Assets/SlideTransitions/Icons/SlideDown.svg"
    );
    setIconSource15(
      apiBaseurl + "/Assets/SlideTransitions/Icons/MashCircle.svg"
    );
    setIconSource18(
      apiBaseurl + "/Assets/SlideTransitions/Icons/DiagonalRays.svg"
    );

    if (ShowTransitionPanel.reset == false) {
      const array = Array.from(slides);
      for (let i = 0; i < array.length; i++) {
        if (array[i].key === ShowTransitionPanel.slideKey) {
          if (array[i].transitionType && array[i].transitionName) {
            setSelectedType(array[i].transitionType);
            setSelectedName(array[i].transitionName);
            break;
          }
        }
        else{
          setSelectedType(null);
          setSelectedName(null);
        }
      }
    }
  }, [ShowTransitionPanel]);
  const { slides, setslides } = useContext(ProjectContext);
  const { apiBaseurl, Access, getLink } = useContext(AuthContext);
  const ResetTransiton = () => {
    setSelectedType(null);
    const array = Array.from(slides);
    console.log('array', array)
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === ShowTransitionPanel.slideKey) {
        if (array[i].transitionType && array[i].transitionName) {
          array[i].transitionType = null;
          array[i].transitionName = null;
        }
      }
    }
    setSelectedName(null);
  };

  const ClosePanel = () => {
    setSelectedType(SelectedType);
    setSelectedName(SelectedName);
    if (SelectedName == null && SelectedType == null) {
      setShowTransitionPanel({
        state: false,
        slideKey: -1, 
        reset: false,
      });
    } else {
      setShowTransitionPanel({
        state: false,
        slideKey: -1,
        reset: false,
      });
    }
  };

  const HrElement = () => {
    return (
      <div
        className="Container"
        style={{ display: "flex", alignItems: "center" }}
      >
        <button
          className="btn btn-yellow btn-small"
          style={{ marginRight: 8 }}
          onClick={() => ResetTransiton()}
        >
          Reset
        </button>
        <span
          class="material-icons closeIconTransition"
          onClick={() => ClosePanel()}
        >
          close
        </span>
      </div>
    );
  };

  const setSlideTransition = (transitionType, transitionName) => {
    const array = Array.from(slides);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === ShowTransitionPanel.slideKey) {
        array[i].transitionType = transitionType;
        array[i].transitionName = transitionName;
        if (array[i].IsActive) {
          array[i].LayerData = LayersData;
        }
        setSelectedType((array[i].transitionType = transitionType));
        setSelectedName((array[i].transitionName = transitionName));
        break;
      }
    }
    setslides(array);
    /* setShowTransitionPanel({
             state: false,
             slideKey: -1,
         })*/
  };

  const PreviewDemoTransition = (e) => {
    if (e.currentTarget.children[1].innerText === "Arrow Move") {
      setIconSource1(
        apiBaseurl + "/Assets/SlideTransitions/Icons/ArrowMove.gif"
      );
    } else if (e.currentTarget.children[1].innerText === "Circle Tunnel") {
      setIconSource2(
        apiBaseurl + "/Assets/SlideTransitions/Icons/CircleTunnel.gif"
      );
    } else if (e.currentTarget.children[1].innerText === "Square Pegs") {
      setIconSource3(
        apiBaseurl + "/Assets/SlideTransitions/Icons/SquarePegs.gif"
      );
    } else if (e.currentTarget.children[1].innerText === "Three Panes") {
      setIconSource4(apiBaseurl + "/Assets/SlideTransitions/Icons/3Panes.gif");
    } else if (e.currentTarget.children[1].innerText === "Fade Shapes") {
      setIconSource5(
        apiBaseurl + "/Assets/SlideTransitions/Icons/FadingShapes.gif"
      );
    } else if (e.currentTarget.children[1].innerText === "Arrow Shuffle") {
      setIconSource6(
        apiBaseurl + "/Assets/SlideTransitions/Icons/ArrowShuffle.gif"
      );
    } else if (e.currentTarget.children[1].innerText === "Line Swipe") {
      setIconSource7(
        apiBaseurl + "/Assets/SlideTransitions/Icons/LineSwipe.gif"
      );
    } else if (e.currentTarget.children[1].innerText === "Square Slice") {
      setIconSource8(
        apiBaseurl + "/Assets/SlideTransitions/Icons/SquareSlice.gif"
      );
    } else if (e.currentTarget.children[1].innerText === "Left Swipe") {
      setIconSource9(
        apiBaseurl + "/Assets/SlideTransitions/Icons/LeftSwipe.gif"
      );
    } else if (e.currentTarget.children[1].innerText === "Spirals") {
      setIconSource10(
        apiBaseurl + "/Assets/SlideTransitions/Icons/Spirals.gif"
      );
    }
    //  else if (e.currentTarget.children[1].innerText === "Tricut") {
    //   setIconSource11(apiBaseurl + "/Assets/SlideTransitions/Icons/11.gif");
    // }
     else if (e.currentTarget.children[1].innerText === "Hor Drop") {
      setIconSource12(apiBaseurl + "/Assets/SlideTransitions/Icons/12.gif");
    } else if (e.currentTarget.children[1].innerText === "Bars") {
      setIconSource16(apiBaseurl + "/Assets/SlideTransitions/Icons/16.gif");
    } else if (e.currentTarget.children[1].innerText === "Wipe Top") {
      setIconSource17(apiBaseurl + "/Assets/SlideTransitions/Icons/17.gif");
    } else if (e.currentTarget.children[1].innerText === "Side Wave") {
      setIconSource13(apiBaseurl + "/Assets/SlideTransitions/Icons/13.gif");
    } else if (e.currentTarget.children[1].innerText === "Slide Down") {
      setIconSource14(apiBaseurl + "/Assets/SlideTransitions/Icons/14.gif");
    } else if (e.currentTarget.children[1].innerText === "Mash Circle") {
      setIconSource15(apiBaseurl + "/Assets/SlideTransitions/Icons/15.gif");
    } else if (e.currentTarget.children[1].innerText === "Diag Rays") {
      setIconSource18(apiBaseurl + "/Assets/SlideTransitions/Icons/18.gif");
    }
  };

  const EndPreviewDemoTransition = (e) => {
    e.preventDefault();
    if (e.currentTarget.children[1].innerText === "Arrow Move") {
      setIconSource1(
        apiBaseurl + "/Assets/SlideTransitions/Icons/ArrowMove.svg"
      );
    } else if (e.currentTarget.children[1].innerText === "Circle Tunnel") {
      setIconSource2(
        apiBaseurl + "/Assets/SlideTransitions/Icons/CircleTunnel.svg"
      );
    } else if (e.currentTarget.children[1].innerText === "Square Pegs") {
      setIconSource3(
        apiBaseurl + "/Assets/SlideTransitions/Icons/SquarePegs.svg"
      );
    } else if (e.currentTarget.children[1].innerText === "Three Panes") {
      setIconSource4(apiBaseurl + "/Assets/SlideTransitions/Icons/3Panes.svg");
    } else if (e.currentTarget.children[1].innerText === "Fade Shapes") {
      setIconSource5(
        apiBaseurl + "/Assets/SlideTransitions/Icons/FadingShapes.svg"
      );
    } else if (e.currentTarget.children[1].innerText === "Arrow Shuffle") {
      setIconSource6(
        apiBaseurl + "/Assets/SlideTransitions/Icons/ArrowShift.svg"
      );
    } else if (e.currentTarget.children[1].innerText === "Line Swipe") {
      setIconSource7(
        apiBaseurl + "/Assets/SlideTransitions/Icons/LineSwipe.svg"
      );
    } else if (e.currentTarget.children[1].innerText === "Square Slice") {
      setIconSource8(
        apiBaseurl + "/Assets/SlideTransitions/Icons/SquareSlice.svg"
      );
    } else if (e.currentTarget.children[1].innerText === "Left Swipe") {
      setIconSource9(
        apiBaseurl + "/Assets/SlideTransitions/Icons/LeftSwipe.svg"
      );
    } else if (e.currentTarget.children[1].innerText === "Spirals") {
      setIconSource10(
        apiBaseurl + "/Assets/SlideTransitions/Icons/Spirals.svg"
      );
    } 
    // else if (e.currentTarget.children[1].innerText === "Tricut") {
    //   setIconSource11(apiBaseurl + "/Assets/SlideTransitions/Icons/Tricut.svg");
    // }
     else if (e.currentTarget.children[1].innerText === "Hor Drop") {
      setIconSource12(
        apiBaseurl + "/Assets/SlideTransitions/Icons/HorDrop.svg"
      );
    } else if (e.currentTarget.children[1].innerText === "Bars") {
      setIconSource16(apiBaseurl + "/Assets/SlideTransitions/Icons/Bars.svg");
    } else if (e.currentTarget.children[1].innerText === "Wipe Top") {
      setIconSource17(
        apiBaseurl + "/Assets/SlideTransitions/Icons/WipeTop.svg"
      );
    } else if (e.currentTarget.children[1].innerText === "Side Wave") {
      setIconSource13(
        apiBaseurl + "/Assets/SlideTransitions/Icons/SideWave.svg"
      );
    } else if (e.currentTarget.children[1].innerText === "Slide Down") {
      setIconSource14(
        apiBaseurl + "/Assets/SlideTransitions/Icons/SlideDown.svg"
      );
    } else if (e.currentTarget.children[1].innerText === "Mash Circle") {
      setIconSource15(
        apiBaseurl + "/Assets/SlideTransitions/Icons/MashCircle.svg"
      );
    } else if (e.currentTarget.children[1].innerText === "Diag Rays") {
      setIconSource18(
        apiBaseurl + "/Assets/SlideTransitions/Icons/DiagonalRays.svg"
      );
    }
  };

  return (
    <div className="Container transitionWrapper">
      <div className="transitionInner">
        <div className="transitionTop mb-3">
          <label className="transitionLabel">Transition Gallery</label>
          <div className="closeIconWrapper">
            <HrElement />
          </div>
        </div>

        <div
          style={{ height: "calc(100% - 48px)", width: "100%" }}
          className="scrollbar style-1"
        >
          <label className="slideCategory ml-1">Basic</label>
          <div className="transitionItemWrapper">
            <div
              onMouseOver={(e) => PreviewDemoTransition(e)}
              onMouseLeave={(e) => EndPreviewDemoTransition(e)}
              className={
                "transitionItemBox" +
                (SelectedType === "basic" && SelectedName === "Arrow_Move"
                  ? " active"
                  : "")
              }
              onClick={() => {
                {
                  setSlideTransition("basic", "Arrow_Move");
                }
              }}
            >
              {/* <img style={{borderRadius: 15,height: 46,marginLeft: 16,marginTop: 0,width:58}} src={IconSource1}/> */}

              <LazyLoadImage
                className="transitionImg"
                effect="blur"
                src={IconSource1}
              />

              <text className="transitionSubLabel">Arrow Move</text>
            </div>

            <div
              onMouseOver={(e) => PreviewDemoTransition(e)}
              onMouseLeave={(e) => EndPreviewDemoTransition(e)}
              className={
                "transitionItemBox" +
                (SelectedType === "basic" && SelectedName === "Circle_Tunnel"
                  ? " active"
                  : "")
              }
              onClick={() => {
                setSlideTransition("basic", "Circle_Tunnel");
              }}
            >
              {/* <img style={{borderRadius: 15,height: 46,marginLeft: 16,marginTop: 0,width:58}} src={IconSource2}/> */}
              <LazyLoadImage
                className="transitionImg"
                effect="blur"
                src={IconSource2}
              />
              <text className="transitionSubLabel">Circle Tunnel</text>
            </div>

            <div
              onMouseOver={(e) => PreviewDemoTransition(e)}
              onMouseLeave={(e) => EndPreviewDemoTransition(e)}
              className={
                "transitionItemBox" +
                (SelectedType === "basic" && SelectedName === "Square_Pegs"
                  ? " active"
                  : "")
              }
              onClick={() => {
                setSlideTransition("basic", "Square_Pegs");
              }}
            >
              {/* <img style={{borderRadius: 15,height: 46,marginLeft: 16,marginTop: 0,width:58}} src={IconSource3}/> */}
              <LazyLoadImage
                className="transitionImg"
                effect="blur"
                src={IconSource3}
              />

              <text className="transitionSubLabel">Square Pegs</text>
            </div>

            <div
              onMouseOver={(e) => PreviewDemoTransition(e)}
              onMouseLeave={(e) => EndPreviewDemoTransition(e)}
              className={
                "transitionItemBox" +
                (SelectedType === "basic" && SelectedName === "3_Panes"
                  ? " active"
                  : "")
              }
              onClick={() => {
                setSlideTransition("basic", "3_Panes");
              }}
            >
              {/* <img style={{borderRadius: 15,height: 46,marginLeft: 16,marginTop: 0,width:58}} src={IconSource4}/> */}
              <LazyLoadImage
                className="transitionImg"
                effect="blur"
                src={IconSource4}
              />

              <text className="transitionSubLabel">Three Panes</text>
            </div>
            <div
              onMouseOver={(e) => PreviewDemoTransition(e)}
              onMouseLeave={(e) => EndPreviewDemoTransition(e)}
              className={
                "transitionItemBox" +
                (SelectedType === "basic" && SelectedName === "Fading_Shapes"
                  ? " active"
                  : "")
              }
              onClick={() => {
                setSlideTransition("basic", "Fading_Shapes");
              }}
            >
              {/* 
                                        <img style={{borderRadius: 15,height: 46,marginLeft: 16,marginTop: 0,width:58}} src={IconSource5}/> */}
              <LazyLoadImage
                className="transitionImg"
                effect="blur"
                src={IconSource5}
              />
              <text className="transitionSubLabel">Fade Shapes</text>
            </div>
            <div
              onMouseOver={(e) => PreviewDemoTransition(e)}
              onMouseLeave={(e) => EndPreviewDemoTransition(e)}
              className={
                "transitionItemBox" +
                (SelectedType === "basic" && SelectedName === "Hor_Drop"
                  ? " active"
                  : "")
              }
              onClick={() => {
                setSlideTransition("basic", "Hor_Drop");
              }}
            >
              <LazyLoadImage
                className="transitionImg"
                effect="blur"
                src={IconSource12}
              />
              <text className="transitionSubLabel">Hor Drop</text>
            </div>
            {/* <div
              onMouseOver={(e) => PreviewDemoTransition(e)}
              onMouseLeave={(e) => EndPreviewDemoTransition(e)}
              className={
                "transitionItemBox" +
                (SelectedType === "basic" && SelectedName === "Bars"
                  ? " active"
                  : "")
              }
              onClick={() => {
                setSlideTransition("basic", "Bars");
              }}
            >
              <LazyLoadImage
                className="transitionImg"
                effect="blur"
                src={IconSource16}
              />
              <text className="transitionSubLabel">Bars</text>
            </div> */}
            <div
              onMouseOver={(e) => PreviewDemoTransition(e)}
              onMouseLeave={(e) => EndPreviewDemoTransition(e)}
              className={
                "transitionItemBox" +
                (SelectedType === "basic" && SelectedName === "Wipe_Top"
                  ? " active"
                  : "")
              }
              onClick={() => {
                setSlideTransition("basic", "Wipe_Top");
              }}
            >
              <LazyLoadImage
                className="transitionImg"
                effect="blur"
                src={IconSource17}
              />
              <text className="transitionSubLabel">Wipe Top</text>
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            {Access === "FE" && (
              <img
                style={{
                  width: "20px",
                  height: "20px",
                  marginTop: "8px",
                }}
                src="../AppIcons/IconsAll/ProIcon.svg"
                alt=""
              />
            )}
            <h5 className="slideCategory ml-1 mt-3">Advanced</h5>{" "}
          </div>

          <div className="transitionItemWrapper">
            <div
              onMouseOver={(e) => PreviewDemoTransition(e)}
              onMouseLeave={(e) => EndPreviewDemoTransition(e)}
              className={
                "transitionItemBox" +
                (SelectedType === "Advanced" && SelectedName === "Arrow_Shuffle"
                  ? " active"
                  : "")
              }
              onClick={() => {
                if (Access === "FE") {
                  Swal.fire({
                    title: "Upgrade Required",
                    html:
                      `You have not purchased this upgrade yet. Please <a href=${getLink()} target='_blank'>upgrade</a> to unlock all features.`,
                    icon: "info",
                    cancelButtonColor: "#d33",
                    backdrop: null,
                  });
                  return;
                }
                setSlideTransition("Advanced", "Arrow_Shuffle");
              }}
            >
              {/* <img style={{borderRadius: 15,height: 46,marginLeft: 16,marginTop: 0,width:58}} src={IconSource6}/> */}

              <LazyLoadImage
                className="transitionImg"
                effect="blur"
                src={IconSource6}
              />

              <text className="transitionSubLabel">Arrow Shuffle</text>
            </div>
            <div
              onMouseOver={(e) => PreviewDemoTransition(e)}
              onMouseLeave={(e) => EndPreviewDemoTransition(e)}
              className={
                "transitionItemBox" +
                (SelectedType === "Advanced" && SelectedName === "Line_Swipe"
                  ? " active"
                  : "")
              }
              onClick={() => {
                if (Access === "FE") {
                  Swal.fire({
                    title: "Upgrade Required",
                    html:
                      `You have not purchased this upgrade yet. Please <a href=${getLink()} target='_blank'>upgrade</a> to unlock all features.`,
                    icon: "info",
                    cancelButtonColor: "#d33",
                    backdrop: null,
                  });
                  return;
                }
                setSlideTransition("Advanced", "Line_Swipe");
              }}
            >
              {/* <img style={{borderRadius: 15,height: 46,marginLeft: 16,marginTop: 0,width:58}} src={IconSource7}/> */}

              <LazyLoadImage
                className="transitionImg"
                effect="blur"
                src={IconSource7}
              />

              <text className="transitionSubLabel">Line Swipe</text>
            </div>

            <div
              onMouseOver={(e) => PreviewDemoTransition(e)}
              onMouseLeave={(e) => EndPreviewDemoTransition(e)}
              className={
                "transitionItemBox" +
                (SelectedType === "Advanced" && SelectedName === "Square_Slice"
                  ? " active"
                  : "")
              }
              onClick={() => {
                if (Access === "FE") {
                  Swal.fire({
                    title: "Upgrade Required",
                    html:
                      `You have not purchased this upgrade yet. Please <a href=${getLink()} target='_blank'>upgrade</a> to unlock all features.`,
                    icon: "info",
                    cancelButtonColor: "#d33",
                    backdrop: null,
                  });
                  return;
                }
                setSlideTransition("Advanced", "Square_Slice");
              }}
            >
              {/*                                                            
<img style={{borderRadius: 15,height: 46,marginLeft: 16,marginTop: 0,width:58}} src={IconSource8}/> */}
              <LazyLoadImage
                className="transitionImg"
                effect="blur"
                src={IconSource8}
              />

              <text className="transitionSubLabel">Square Slice</text>
            </div>
            {/* <div
              onMouseOver={(e) => PreviewDemoTransition(e)}
              onMouseLeave={(e) => EndPreviewDemoTransition(e)}
              className={
                "transitionItemBox" +
                (SelectedType === "Advanced" && SelectedName === "Left_Swipe"
                  ? " active"
                  : "")
              }
              onClick={() => {
                setSlideTransition("Advanced", "Left_Swipe");
              }}
            >
          
              <LazyLoadImage
                className="transitionImg"
                effect="blur"
                src={IconSource9}
              />

              <text className="transitionSubLabel">Left Swipe</text>
            </div> */}
            <div
              onMouseOver={(e) => PreviewDemoTransition(e)}
              onMouseLeave={(e) => EndPreviewDemoTransition(e)}
              className={
                "transitionItemBox" +
                (SelectedType === "Advanced" && SelectedName === "Spirals"
                  ? " active"
                  : "")
              }
              onClick={() => {
                if (Access === "FE") {
                  Swal.fire({
                    title: "Upgrade Required",
                    html:
                      `You have not purchased this upgrade yet. Please <a href=${getLink()} target='_blank'>upgrade</a> to unlock all features.`,
                    icon: "info",
                    cancelButtonColor: "#d33",
                    backdrop: null,
                  });
                  return;
                }
                setSlideTransition("Advanced", "Spirals");
              }}
            >
              <LazyLoadImage
                className="transitionImg"
                effect="blur"
                src={IconSource10}
              />
              <text className="transitionSubLabel">Spirals</text>
            </div>
            {/* <div
              onMouseOver={(e) => PreviewDemoTransition(e)}
              onMouseLeave={(e) => EndPreviewDemoTransition(e)}
              className={
                "transitionItemBox" +
                (SelectedType === "Advanced" && SelectedName === "Tricut"
                  ? " active"
                  : "")
              }
              onClick={() => {
                if (Access === "FE") {
                  Swal.fire({
                    title: "Upgrade Required",
                    html:
                      `You have not purchased this upgrade yet. Please <a href=${getLink()} target='_blank'>upgrade</a> to unlock all features.`,
                    icon: "info",
                    cancelButtonColor: "#d33",
                    backdrop: null,
                  });
                  return;
                }
                setSlideTransition("Advanced", "Tricut");
              }}
            >
              <LazyLoadImage
                className="transitionImg"
                effect="blur"
                src={IconSource11}
              />
              <text className="transitionSubLabel">Tricut</text>
            </div> */}
            <div
              onMouseOver={(e) => PreviewDemoTransition(e)}
              onMouseLeave={(e) => EndPreviewDemoTransition(e)}
              className={
                "transitionItemBox" +
                (SelectedType === "Advanced" && SelectedName === "Side_Wave"
                  ? " active"
                  : "")
              }
              onClick={() => {
                if (Access === "FE") {
                  Swal.fire({
                    title: "Upgrade Required",
                    html:
                      `You have not purchased this upgrade yet. Please <a href=${getLink()} target='_blank'>upgrade</a> to unlock all features.`,
                    icon: "info",
                    cancelButtonColor: "#d33",
                    backdrop: null,
                  });
                  return;
                }
                setSlideTransition("Advanced", "Side_Wave");
              }}
            >
              <LazyLoadImage
                className="transitionImg"
                effect="blur"
                src={IconSource13}
              />
              <text className="transitionSubLabel">Side Wave</text>
            </div>
            <div
              onMouseOver={(e) => PreviewDemoTransition(e)}
              onMouseLeave={(e) => EndPreviewDemoTransition(e)}
              className={
                "transitionItemBox" +
                (SelectedType === "Advanced" && SelectedName === "Slide_Down"
                  ? " active"
                  : "")
              }
              onClick={() => {
                if (Access === "FE") {
                  Swal.fire({
                    title: "Upgrade Required",
                    html:
                      `You have not purchased this upgrade yet. Please <a href=${getLink()} target='_blank'>upgrade</a> to unlock all features.`,
                    icon: "info",
                    cancelButtonColor: "#d33",
                    backdrop: null,
                  });
                  return;
                }
                setSlideTransition("Advanced", "Slide_Down");
              }}
            >
              <LazyLoadImage
                className="transitionImg"
                effect="blur"
                src={IconSource14}
              />
              <text className="transitionSubLabel">Slide Down</text>
            </div>
            <div
              onMouseOver={(e) => PreviewDemoTransition(e)}
              onMouseLeave={(e) => EndPreviewDemoTransition(e)}
              className={
                "transitionItemBox" +
                (SelectedType === "Advanced" && SelectedName === "Mash_Circle"
                  ? " active"
                  : "")
              }
              onClick={() => {
                if (Access === "FE") {
                  Swal.fire({
                    title: "Upgrade Required",
                    html:
                      `You have not purchased this upgrade yet. Please <a href=${getLink()} target='_blank'>upgrade</a> to unlock all features.`,
                    icon: "info",
                    cancelButtonColor: "#d33",
                    backdrop: null,
                  });
                  return;
                }
                setSlideTransition("Advanced", "Mash_Circle");
              }}
            >
              <LazyLoadImage
                className="transitionImg"
                effect="blur"
                src={IconSource15}
              />
              <text className="transitionSubLabel">Mash Circle</text>
            </div>
            <div
              onMouseOver={(e) => PreviewDemoTransition(e)}
              onMouseLeave={(e) => EndPreviewDemoTransition(e)}
              className={
                "transitionItemBox" +
                (SelectedType === "Advanced" && SelectedName === "Diagonal_Rays"
                  ? " active"
                  : "")
              }
              onClick={() => {
                if (Access === "FE") {
                  Swal.fire({
                    title: "Upgrade Required",
                    html:
                      `You have not purchased this upgrade yet. Please <a href=${getLink()} target='_blank'>upgrade</a> to unlock all features.`,
                    icon: "info",
                    cancelButtonColor: "#d33",
                    backdrop: null,
                  });
                  return;
                }
                setSlideTransition("Advanced", "Diagonal_Rays");
              }}
            >
              <LazyLoadImage
                className="transitionImg"
                effect="blur"
                src={IconSource18}
              />
              <text className="transitionSubLabel">Diag Rays</text>
            </div>
            {/* <div className={"transitionItemBox" + ((SelectedType === "stylized" && SelectedName === "fade") ? " active" : '')}
                                onClick={() => { setSlideTransition("stylized", "fade") }}>Fade</div>

                            <div className={"transitionItemBox" + ((SelectedType === "stylized" && SelectedName === "zoom_in") ? " active" : '')}
                                onClick={() => { setSlideTransition("stylized", "zoom_in") }}>Zoom In</div>

                            <div className={"transitionItemBox" + ((SelectedType === "stylized" && SelectedName === "zoom_out") ? " active" : '')}
                                onClick={() => { setSlideTransition("stylized", "zoom_out") }}>Zoom Out</div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SlideTransitions;
